<template>
  <v-card flat class="pa-0 clinical-form">
    <div v-if="readonly" class="clinical-readonly">
      <div v-for="field in readonlyFields" :key="field.key" v-show="field.value" class="clinical-readonly__item">
        <p class="clinical-readonly__label">{{ field.label }}</p>
        <p class="clinical-readonly__value">{{ field.value }}</p>
      </div>
      <p v-if="!readonlyFields.some(field => field.value)" class="caption grey--text">—</p>
    </div>
    <v-row v-else no-gutters>
      <v-col cols="12">
        <v-textarea
          v-model="localModel.history"
          outlined
          dense
          :label="_getLabel('HISTORY')"
          rows="2"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="localModel.currentMedications"
          outlined
          dense
          :label="_getLabel('CURRENT_MEDICATIONS')"
          rows="2"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="localModel.allergies"
          outlined
          dense
          :label="_getLabel('ALLERGIES')"
          rows="2"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="localModel.diet"
          outlined
          dense
          :label="_getLabel('DIET')"
          rows="2"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="localModel.environment"
          outlined
          dense
          :label="_getLabel('ENVIRONMENT')"
          rows="2"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="localModel.reproductive"
          outlined
          dense
          :label="_getLabel('REPRODUCTIVE_STATUS')"
          rows="2"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="localModel.previousDiseases"
          outlined
          dense
          :label="_getLabel('PREVIOUS_DISEASES')"
          rows="2"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="localModel.vaccination"
          outlined
          dense
          :label="_getLabel('VACCINATION_STATUS')"
          rows="2"
        ></v-textarea>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "AnamnesisForm",
  props: {
    value: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    readonly: { type: Boolean, default: false },
  },
  computed: {
    readonlyFields() {
      return [
        ['history', 'HISTORY'], ['currentMedications', 'CURRENT_MEDICATIONS'],
        ['allergies', 'ALLERGIES'], ['diet', 'DIET'], ['environment', 'ENVIRONMENT'],
        ['reproductive', 'REPRODUCTIVE_STATUS'], ['previousDiseases', 'PREVIOUS_DISEASES'],
        ['vaccination', 'VACCINATION_STATUS'],
      ].map(([key, label]) => ({ key, label: this._getLabel(label), value: this.localModel[key] }));
    },
  },
  data() {
    return {
      localModel: { ...this.value },
    };
  },
  watch: {
    value: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.localModel)) {
          this.localModel = { ...(val || {}) };
        }
      },
      deep: true,
    },
    localModel: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.value)) {
          this.$emit("input", val);
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.clinical-readonly__item { padding: 12px 0; border-bottom: 1px solid #e7eaf0; }
.clinical-readonly__label { color: #667085; font-size: 12px; font-weight: 700; margin: 0 0 4px; }
.clinical-readonly__value { color: #193153; font-size: 14px; line-height: 1.5; white-space: pre-wrap; margin: 0; }
.clinical-readonly__item:last-child { border-bottom: 0; }
</style>
